// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyA3Fvsy7oQZAuoH7K_oNx0hmKeqSHeRm6o",
    authDomain: "mawe-shop.firebaseapp.com",
    projectId: "mawe-shop",
    storageBucket: "mawe-shop.appspot.com",
    messagingSenderId: "568107857784",
    appId: "1:568107857784:web:5254a324baa9b2dd1bba8d",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
